// @flow

import * as React from 'react';

import { Outlet } from 'react-router-dom';

import { withPageMeta } from '@gandi/app-runner';

import PreferencesWidget from '../Layout/components/PreferencesWidget/PreferencesWidget';
import { Layout } from '../components/Layout';

import { handleMarketingParams } from '../modules/app/actions';
import type { StaticHandlerArgsWithMarketing } from '../modules/app/actions';
import type { PreFetchArgs, FullState } from '../types';

function SimpleHosting() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

SimpleHosting.handleRedirect = async function handleRedirect(
  args: StaticHandlerArgsWithMarketing<>,
) {
  await handleMarketingParams(args);
  await PreferencesWidget.handleRedirect(args);
};

SimpleHosting.preFetch = (args: PreFetchArgs<{}, void, empty, FullState>) =>
  PreferencesWidget.preFetch(args);

export default (withPageMeta(({ __ }) => ({
  title: __('Simple Hosting - Gandi.net'),
  description: __(
    'For websites and web applications of all sizes. ' +
      'Try your first instance of any size for free for 10 days ' +
      'with a free Gandi account. No credit card required.',
  ),
}))(SimpleHosting): React.ComponentType<{}>);
